import { useState, useEffect } from 'react';

const BlogGallery = () => {
  const [posts, setPosts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 【重要】ここを自分のドメイン（例: https://usuki-fry.com）に書き換えてください
    const domain = 'https://mm.ai-adult.org'; 
    const wpUrl = `${domain}/wp-json/wp/v2/posts?_embed&per_page=6`;

    fetch(wpUrl)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((post: any) => ({
          id: post.id,
          title: post.title.rendered,
          image: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || 'https://images.unsplash.com/photo-1506744038136-46273834b3fb',
          excerpt: post.excerpt.rendered.replace(/<[^>]+>/g, '').substring(0, 80) + '...',
          date: new Date(post.date).toLocaleDateString('ja-JP'),
          link: post.link,
        }));
        setPosts(formatted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="py-20 text-center text-gray-500">読み込み中...</div>;

  return (
    <section id="blog" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-12">最新の活動記録</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:-translate-y-2 transition-transform duration-300">
              <img src={post.image} className="w-full h-48 object-cover" alt="" />
              <div className="p-6">
                <p className="text-xs text-gray-400 mb-2">{post.date}</p>
                <h3 className="font-bold text-xl mb-3" dangerouslySetInnerHTML={{ __html: post.title }} />
                <p className="text-sm text-gray-600 mb-4">{post.excerpt}</p>
                <a href={post.link} className="text-teal-500 font-bold">続きを読む →</a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGallery;
